module.exports = __webpack_public_path__ + "img/SKMP.0574b456.svg";